<script>
export default {
  name: "BankImage",
  props: {
    ibanObject: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div class="iban-img-container">
    <v-img
      width="30"
      :src="
        require(`@/assets/img/banks/${parseInt(
          ibanObject?.iban?.slice(4, 7)
        )}.svg`)
      "
    />
  </div>
</template>

<style scoped lang="scss">
.iban-img-container {
  max-width: 60px;
  padding: 15px;
  margin-left: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background-color: #ffffff;
}
</style>
